import Axios from "../../axios";
import { ApiResponse } from "../../apiResponse";


export function studentRatings(rating: object): Promise<ApiResponse> {
  return Axios.post("/v1/students/ratings", rating);
}
